module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authedRoute && !_vm.liveFeed.disabled) ? _c('div', {
    attrs: {
      "id": "liveFeed"
    }
  }, [(_vm.liveFeed.open) ? _c('div', {
    attrs: {
      "id": "openTradeNewsFeedSection"
    }
  }, [_c('logo-loader', {
    attrs: {
      "isActive": _vm.localLogoLoaderActive,
      "position": "absolute"
    }
  }), _vm._v(" "), _vm._l((_vm.liveFeedSorted), function(index) {
    return _c('div', {
      key: _vm.liveFeed.data[index].orderID,
      staticClass: "newsFeed",
      class: [{
        'update': _vm.liveFeed.data[index].update
      } ].concat( _vm.liveFeed.data[index].cssClass)
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "newsDataContainer"
    }, [_c('p', {
      staticClass: "accName has-text-primary"
    }, [_c('span', {
      staticClass: "has-text-weight-bold"
    }, [_vm._v(_vm._s(_vm.liveFeed.data[index].accountName))]), _vm._v(" | " + _vm._s(_vm.liveFeed.data[index].tradingAccount))]), _vm._v(" "), _c('p', [_vm._v("Opened a " + _vm._s(_vm.liveFeed.data[index].orderType) + " position on " + _vm._s(_vm.$simplePair(_vm.liveFeed.data[index].pair)) + " at " + _vm._s(_vm.liveFeed.data[index].openPrice))]), _vm._v(" "), _c('p', {
      staticClass: "has-text-primary likeIcon",
      class: {
        'liked': _vm.liveFeed.data[index].liked
      },
      on: {
        "click": function($event) {
          return _vm.like(index)
        }
      }
    }), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "has-text-primary is-pulled-left"
    }, [_vm._v(_vm._s(_vm.liveFeed.data[index].likeTotal) + " likes")]), _vm._v(" "), _c('span', {
      staticClass: "is-pulled-right"
    }, [_c('div', {
      staticClass: "clockIcon"
    }), _vm._v(_vm._s(_vm.$dateFromNow(_vm.liveFeed.data[index].openDate)))])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'open': _vm.liveFeed.open
    },
    attrs: {
      "id": "openTradeNewsFeedMini"
    },
    on: {
      "click": function($event) {
        _vm.liveFeed.open = !_vm.liveFeed.open
      }
    }
  }, [(_vm.liveFeed.unseen > 0) ? _c('div', {
    staticClass: "miniSubSection",
    attrs: {
      "id": "newsFeedCounter"
    }
  }, [_vm._v(_vm._s(_vm.liveFeed.unseen))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "miniSubSection",
    attrs: {
      "id": "newsFeedIcon"
    }
  }), _vm._v(" "), (!_vm.liveFeed.open) ? _c('div', {
    staticClass: "miniSubSection",
    attrs: {
      "id": "maxButton"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.liveFeed.open) ? _c('div', {
    staticClass: "miniSubSection",
    attrs: {
      "id": "maxButton"
    }
  }) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsFeedIconContainer"
  }, [_c('div', {
    staticClass: "newsFeedIcon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-908555a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveFeed.vue
// module id = 794
// module chunks = 0